/**
 * Cancels and releases a ReadableStreamDefaultReader to prevent resource leaks.
 * This utility handles the cancellation and lock release with proper error handling.
 *
 * @param reader - The stream reader to cancel and release
 */
export function cancelStreamReader(reader: ReadableStreamDefaultReader<Uint8Array>): void {
  try {
    // Cancel the reader asynchronously
    void reader.cancel().catch((error) => {
      // Reader may already be cancelled or released
      console.warn('Error cancelling stream reader:', error);
    });

    // Release the lock to prevent resource leak
    // This must be called here because the finally block in processAnswerStream
    // checks if currentReaderRef.current === reader, and if we've already nullified
    // the ref, the finally block won't release the lock
    try {
      reader.releaseLock();
    } catch (releaseError) {
      // Lock may already be released (shouldn't happen, but handle gracefully)
      console.warn('Error releasing stream reader lock:', releaseError);
    }
  } catch (error) {
    // Synchronous error (shouldn't happen, but handle just in case)
    console.warn('Error cancelling stream reader:', error);
    // Still try to release the lock even if cancel failed
    try {
      reader.releaseLock();
    } catch (releaseError) {
      console.warn('Error releasing stream reader lock:', releaseError);
    }
  }
}
